import { colors, createTheme } from "@mui/material";
import { CRIMSON_RED, PRIMARY_BLUE } from "../../enums/Colors";
import fabric from "../../../src/assets/png/darkBackground.png";
import { CHIP_MIN_WIDTH } from "../../enums/Styles";
const base_color = PRIMARY_BLUE;
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: base_color,
    },
    secondary: {
      main: "#fff",
    },
    info: {
      main: base_color,
    },
    warning: {
      main: "#fb8500",
    },
    error: {
      main: CRIMSON_RED,
    },
    background: {
      default: "#121212",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: `url(${fabric})`, //Imprt the texture from the IMGs folder at the top of the class before appending it
          backgroundAttachment: "fixed",
          backgroundPosition: "center center",
        },
        ".MuiButton-root.Mui-button-positive": {
          //made with higher specificity so it actually applies
          flexShrink: 0,
        },
        ".MuiButton-root.Mui-button-negative": {
          flexShrink: 0,
        },
        ".MuiButton-root.Mui-button-next": {
          flexShrink: 0,
        },
        ".MuiButton-root.Mui-button-back": {
          flexShrink: 0,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          // MUI zeroes the top padding under a DialogTitle, and the content scrolls,
          // so a focused field's floating label on the first row got clipped
          ".MuiDialogTitle-root + &": {
            paddingTop: 12,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "&.Mui-blue-colored": {
            backgroundColor: base_color,
            color: "#fff",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          "&.Mui-fullscreen-icon": {
            color: base_color,
            fontSize: "80px",
          },
          "&.Mui-confirmation-dialog-icon": {
            color: base_color,
            fontSize: "120px",
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            // Styles for the selected chip
            backgroundColor: base_color,
            color: "#fff",
          },
          "&.Mui-error": {
            backgroundColor: CRIMSON_RED,
            color: "#fff",
          },
          "&.Mui-selected .MuiChip-icon": {
            // Customize the icon when the chip is selected
            color: "#fff", // Change icon color
          },
          padding: 2,
          justifyContent: "start",
          "&.MuiChip-colorPrimary": {
            backgroundColor: base_color,
            color: "#fff",
          },
          "&.MuiChip-colorSecondary": {
            backgroundColor: base_color,
            color: "#fff",
          },
          "&.MuiChip-outlined": {
            backgroundColor: base_color,
            color: "#000",
          },
        },
      },
    },
  },
});
